module.exports = __webpack_public_path__ + "static/media/navi_background.10982949.jpg";